module.exports = __webpack_public_path__ + "img/The-Micro.7706277c.jpg";